import ValidatedForm from "@/validation/ValidatedForm";
import Currency from "@/server/com/silkplm/model/plm/dictionaries/Currency";
import Dictionary from "@/server/com/silkplm/engine/model/Dictionary";
import DynamicAttribute from "@/server/com/silkplm/model/plm/dictionaries/DynamicAttribute";
import CategoryAttributes from "@/server/com/silkplm/model/plm/CategoryAttributes";
import FormsLoader from "@/components/forms/FormsLoader";

class _Loader {
    constructor() {
        this.dictionaries = {};
        this.dynamicColumnsClasses = {};
        this.dynamicDictionaries = null;
        this.dynamicAttributes = null;
        this.categoryAttributes = null;
        this.dynamicEntities = {};
        EventBus.$on(ServerEvents.dictionaryChange, (val) => {
            this.processEventOnDictionaryChange(val);
        });
        EventBus.$on(ServerEvents.dynamicColumnEventChange, (val) => {
            this.processEventOnDynamicColumnEventChange(val);
        });
        EventBus.$on(ServerEvents.dynamicDictionaryEventChange, () => {
            this.processEventOnDynamicDictionaryChange();
        });
        EventBus.$on(ServerEvents.dynamicDictionaryEventChange, () => {
            this.processEventOnDynamicEntityChange();
        });
        EventBus.$on(ServerEvents.dynamicAttributeEventChange, () => {
            this.processEventOnDynamicAttributeChange();
        });
        EventBus.$on(ServerEvents.categoryAttributeEventChange, () => {
            this.processEventCategoryAttributeChange();
        });
        EventBus.$on(ServerEvents.dynamicEntityEventChange, () => {
            this.processEventOnDynamicEntityChange();
        });
    }

    processEventOnDynamicColumnEventChange(val) {
        this.dynamicColumnsClasses[val.clazz] = undefined;
    }

    processEventOnDictionaryChange(val) {
        this.dictionaries[val.dictionaryClazz] = undefined;
    }

    processEventOnDynamicDictionaryChange() {
        this.dynamicDictionaries = null;
    }

    processEventOnDynamicEntityChange() {
        this.dynamicEntities = {};
    }

    processEventOnDynamicAttributeChange() {
        this.dynamicAttributes = null;
    }

    processEventCategoryAttributeChange() {
        this.categoryAttributes = null;
    }

    async getDictionary(clazz) {
        if (this.dictionaries[clazz] !== undefined) {
            return this.dictionaries[clazz];
        }
        this.dictionaries[clazz] = await Rpc.Forms.listEntities(clazz);
        return this.dictionaries[clazz];
    }

    async getDynamicColumnsNumber(clazz) {
        if (this.dynamicColumnsClasses[clazz] !== undefined) {
            return this.dynamicColumnsClasses[clazz];
        }
        this.dynamicColumnsClasses[clazz] = await Rpc.Forms.countAllEntitiesByClassName(clazz);
        return this.dynamicColumnsClasses[clazz];
    }

    async getDynamicDictionaries() {
        if (this.dynamicDictionaries !== null) {
            return this.dynamicDictionaries;
        }
        let dynamicDictionaries = await Dictionary.list();
        this.dynamicDictionaries = {};
        dynamicDictionaries.forEach((el) => {
            this.dynamicDictionaries[el.id] = el;
        });
        return this.dynamicDictionaries;
    }

    async getDynamicAttributes() {
        if (this.dynamicAttributes !== null) {
            return this.dynamicAttributes;
        }
        let dynamicAttributes = await DynamicAttribute.list();
        this.dynamicAttributes = {};
        dynamicAttributes.forEach((el) => {
            this.dynamicAttributes[el.id] = el;
        });
        return this.dynamicAttributes;
    }

    async getDynamicEntities(clazz) {
        if (this.dynamicEntities[clazz] !== undefined) {
            return this.dynamicEntities[clazz];
        }
        this.dynamicEntities[clazz] = await Rpc.Forms.listDynamicExtendedEntities(clazz);
        return this.dynamicEntities[clazz];
    }

    async getDynamicEntity(clazz, uuid) {
        let dictionaryValues = await this.getDynamicEntities(clazz);
        if (!dictionaryValues) {
            return null;
        }
        let dict = dictionaryValues.filter((el) => el.id === uuid);
        if (!dict?.length) {
            return null;
        }
        return dict[0].value;
    }

    async getCategoryAttributes() {
        if (this.categoryAttributes !== null) {
            return this.categoryAttributes;
        }
        let categoryAttributes = await CategoryAttributes.list();
        this.categoryAttributes = {};
        categoryAttributes.forEach((el) => {
            this.categoryAttributes[el.id] = el;
        });
        return this.categoryAttributes;
    }

    reset() {
        this.dictionaries = {};
        this.dynamicColumnsClasses = {};
        this.dynamicDictionaries = null;
        this.dynamicAttributes = null;
        this.categoryAttributes = null;
        this.dynamicEntities = {};
    }
}

const CacheManager = new _Loader();
export default CacheManager;
